const IGDB_SOURCE_FALLBACK = 'IGDB';

interface BuildIgdbSourceArgs {
  genres?: string[];
  platforms?: string[];
}

export const buildIgdbSource = ({ genres, platforms }: BuildIgdbSourceArgs): string => {
  if (genres?.length && platforms?.length) {
    return `${genres.join(', ')} / ${platforms.join(', ')}`;
  }

  if (genres?.length) {
    return genres.join(', ');
  }

  if (platforms?.length) {
    return platforms.join(', ');
  }

  return IGDB_SOURCE_FALLBACK;
};
